import { render } from "./InputNumberCustom.vue?vue&type=template&id=6fa56f34"
import script from "./InputNumberCustom.vue?vue&type=script&lang=js"
export * from "./InputNumberCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__